import React, { useState, useMemo, useCallback } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import OrderItems from './OrderItems'
import DxDataTable from 'components/DxDataTable'
import { dxOrderCols } from './columns'
import { useQuery } from 'components/graphql'
import { listCashRegistersShop } from 'gql/query'
import { listOrderTypes } from '../../gql'
import useLocale from 'hooks/useLocale'
import { getMaxTableHeight } from '../helpers'

const OrdersTable = ({ data = [] }) => {
	const [selectedOrder, setSelectedOrder] = useState(null)
	const [initialOrder, setInitialOrder] = useState(null)
	const { data: listCashRegisters, queryField } = useQuery(listCashRegistersShop, { fetchPolicy: 'cache-first' })
	const { data: orderTypes, queryField: listTypesField } = useQuery(listOrderTypes, { fetchPolicy: 'cache-first' })
	const [t] = useTranslation()
	const locales = useLocale()
	const getTableHeight = useCallback(() => getMaxTableHeight('ordersTable'))
	const orderColumns = dxOrderCols({ t, locales })

	const transferOrders = orderTypes?.[listTypesField]?.items?.reduce?.((outArr, item) => {
		if(item?.isActive && item?.orderType === 3) {
			outArr.push(item.name)
		}
		return outArr
	}, []) || []

	const tableData = useMemo(() => {
		const shopNames = {}

		return data?.map?.(object => {
			const item = { ...object }

			const { cashRegisterId } = item
			if(cashRegisterId) {
				if(shopNames[cashRegisterId]) {
					item.shopName = shopNames[cashRegisterId]
				} else {
					const { shop } = listCashRegisters?.[queryField]?.find?.(cr => Number(cr.id) === Number(cashRegisterId)) || {}
					shopNames[cashRegisterId] = shop?.name
					item.shopName = shop?.name
				}
			}
			if(transferOrders.indexOf(item?.orderTypeName) > -1) {
				const suffix = item.total > 0 ? t('common.strings.received') : t('common.strings.sent')
				item.orderTypeName += ' ' + suffix
			}
			return item
		})
	}, [listCashRegisters, queryField, data])

	const handleSelect = row => {
		setInitialOrder(row)
		const rowData = orderColumns.reduce?.((out, cell) => {
			const { caption, dataField, cellRender } = cell
			out[caption] = typeof cellRender === 'function'
				? cellRender({ cell: { value: row[dataField] }, value: row[dataField] })
				: row[dataField]
			return out
		}, {})
		setSelectedOrder(rowData)
	}

	return (
		<Row>
			<Col xs={6}>
				<DxDataTable
					id='ordersTable'
					data={tableData}
					columns={orderColumns}
					withSearch={false}
					height={getTableHeight}
					label={t('statistic_section.strings.erp_data')}
					onRowClick={handleSelect}
					columnAutoWidth={false}
				/>
			</Col>
			<Col xs={6}>
				{selectedOrder &&
					<OrderItems
						initialSelectedOrder={initialOrder}
						key={selectedOrder?.id}
						orderData={selectedOrder}
					/>
				}
			</Col>
		</Row>
	)
}

export default OrdersTable
